import { LinkType } from "@tager/admin-ui";
import { getMenuPageUrl } from "@tager/admin-menus";
import { getSettingItemListUrl } from "@tager/admin-settings";
import { getPageListUrl } from "@tager/admin-pages";
import { getBlogCategoryListUrl, getBlogPostListUrl } from "@tager/admin-blog";
import { getSeoSettingsUrl, getSeoTemplatesUrl } from "@tager/admin-seo";
import { getAdminListUrl, getRoleListUrl } from "@tager/admin-administrators";
import { getEmailLogListUrl, getEmailTemplateListUrl } from "@tager/admin-mail";
import { getExportListUrl } from "@tager/admin-export";
import { getImportListUrl } from "@tager/admin-import";
import { getFilesListUrl } from "@tager/admin-files";

import {
  getBasisProductListUrl,
  getBrandListUrl,
  getCategoryListUrl,
  getCategoryTreeUrl,
  getCollectionListUrl,
  getProductListUrl,
  getProductTypeListUrl,
  getSeoListUrl,
  getSpecialListUrl,
  getTermListUrl,
} from "@/utils/paths";

type LinkKey =
  | "HOME"
  | "PRODUCT_LIST"
  | "BASIS_PRODUCT_LIST"
  | "PRODUCT_PRICE_LIST"
  | "PRODUCT_PARAM_LIST"
  | "PRODUCT_IMPORT_LIST"
  | "CATEGORY_LIST"
  | "CATEGORY_TREE"
  | "SPECIAL_LIST"
  | "SEO_LIST_CATEGORY"
  | "BRANDS_LIST"
  | "COLLECTION_LIST"
  | "PRODUCT_GROUP_LIST"
  | "PRODUCT_TYPE_LIST"
  | "PAGE_LIST"
  | "MENU_TOP"
  | "MENU_MAIN"
  | "MENU_CATALOG"
  | "MENU_BOTTOM"
  | "BLOG_POST_LIST"
  | "BLOG_CATEGORY_LIST"
  | "TERM"
  | "EMAIL_TEMPLATE_LIST"
  | "EMAIL_LOG_LIST"
  | "SETTINGS_COMMON"
  | "SEO_SETTINGS"
  | "SEO_TEMPLATES"
  | "ADMIN_ROLES"
  | "EXPORT_LIST"
  | "IMPORT_LIST"
  | "FILES_LIST"
  | "ADMIN_ADMINS";

export const LINKS: Readonly<Record<LinkKey, LinkType>> = {
  HOME: {
    url: "/",
    text: "Главная",
  },
  PRODUCT_LIST: {
    url: getProductListUrl(),
    text: "Все товары",
  },
  BASIS_PRODUCT_LIST: {
    url: getBasisProductListUrl(),
    text: "Базовые товары",
  },
  PRODUCT_PRICE_LIST: {
    url: "/products/prices",
    text: "Цены и наличие",
  },
  PRODUCT_PARAM_LIST: {
    url: "/products/params",
    text: "Характеристики",
  },
  PRODUCT_IMPORT_LIST: {
    url: "/products/import",
    text: "Импорт / Экспорт",
  },
  CATEGORY_LIST: {
    url: getCategoryListUrl(),
    text: "Товарные категории",
  },
  CATEGORY_TREE: {
    url: getCategoryTreeUrl(),
    text: "Дерево категорий",
  },
  FILES_LIST: {
    url: getFilesListUrl(),
    text: "Файлы",
  },
  SPECIAL_LIST: {
    url: getSpecialListUrl(),
    text: "Спецпредложения",
  },
  SEO_LIST_CATEGORY: {
    url: getSeoListUrl(),
    text: "Категории",
  },
  BRANDS_LIST: {
    url: getBrandListUrl(),
    text: "Производители",
  },
  COLLECTION_LIST: {
    url: getCollectionListUrl(),
    text: "Коллекции",
  },
  PRODUCT_TYPE_LIST: {
    url: getProductTypeListUrl(),
    text: "Типы товаров",
  },
  PRODUCT_GROUP_LIST: {
    url: "/product-groups",
    text: "Группы товаров",
  },
  PAGE_LIST: {
    url: getPageListUrl(),
    text: "Cтраницы",
  },
  MENU_TOP: {
    url: getMenuPageUrl("top"),
    text: "Верхнее меню",
  },
  MENU_MAIN: {
    url: getMenuPageUrl("main"),
    text: "Главное меню",
  },
  MENU_CATALOG: {
    url: getMenuPageUrl("catalog"),
    text: "Каталог",
  },
  MENU_BOTTOM: {
    url: getMenuPageUrl("footer"),
    text: "Нижнее меню",
  },
  BLOG_POST_LIST: {
    url: getBlogPostListUrl(),
    text: "Посты",
  },
  BLOG_CATEGORY_LIST: {
    url: getBlogCategoryListUrl(),
    text: "Категории",
  },
  EMAIL_TEMPLATE_LIST: {
    url: getEmailTemplateListUrl(),
    text: "Шаблоны",
  },
  EMAIL_LOG_LIST: {
    url: getEmailLogListUrl(),
    text: "Логи",
  },
  SETTINGS_COMMON: {
    url: getSettingItemListUrl(),
    text: "Основные",
  },
  /** Term */
  TERM: { url: getTermListUrl(), text: "Словарь" },

  SEO_SETTINGS: {
    url: getSeoSettingsUrl(),
    text: "SEO Настройки",
  },
  SEO_TEMPLATES: {
    url: getSeoTemplatesUrl(),
    text: "Шаблоны",
  },
  ADMIN_ROLES: {
    url: getRoleListUrl(),
    text: "Роли",
  },
  ADMIN_ADMINS: {
    url: getAdminListUrl(),
    text: "Администраторы",
  },
  EXPORT_LIST: {
    url: getExportListUrl(),
    text: "Экспорт",
  },
  IMPORT_LIST: {
    url: getImportListUrl(),
    text: "Импорт",
  },
};
